import React from 'react';
import {compose} from 'redux';
import {connect} from 'react-redux';
import {Column, Row} from '../layout';
import * as fonts from '../../util/fonts';
import CoveragesProgressBar from '../../containers/coverages/components/CoveragesProgressBar';
import {CoveragesItem} from '../../containers/coverages/Coverages';
import './styles.scss';
import {getCurrencyCode} from '../../util/utility';

interface CoverageCardProps {
  details?: Boolean;
  coveragesItem: CoveragesItem;
  buStyles: any;
  language: string;
  userLanguage: string;
  myCoverageStrings: any;
}

const CoverageCard = ({
  details,
  coveragesItem,
  buStyles,
  language,
  userLanguage,
  myCoverageStrings,
}: CoverageCardProps) => {
  const primaryColor = buStyles.primaryColor || '#000000';

  const currentLanguage = language || userLanguage;

  const currencyFormat = (value: number) =>
    new Intl.NumberFormat(currentLanguage, {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    }).format(value);

  const listCatNameStyle = {
    color: primaryColor,
  };

  const onWebMobile = window.innerWidth <= 768;

  const catNameDefaultStyle = onWebMobile
    ? {
        ...fonts.M,
        ...fonts.Bold,
        paddingBottom: '12px',
        paddingRight: '10px',
      }
    : {
        ...fonts.ML,
        ...fonts.Bold,
        paddingBottom: '12px',
        paddingRight: '10px',
      };

  const coveragesListColumn2Styles = onWebMobile
    ? {
        ...fonts.ML,
        fontSize: '12px',
      }
    : {
        ...fonts.ML,
        ...fonts.Bold,
        fontSize: '17px',
      };

  return (
    <Row style={{marginBottom: '20px', width: details ? '50%' : 'unset'}}>
      <Column className="coverages-list-column1">
        <strong
          style={
            details
              ? catNameDefaultStyle
              : {...catNameDefaultStyle, ...listCatNameStyle}
          }>
          {coveragesItem.catName}
        </strong>
        <CoveragesProgressBar
          className="coverages-progress-bar"
          progress={
            coveragesItem.limitAmt >= 0
              ? coveragesItem.amtSpent
              : coveragesItem.limitCount > 0
              ? coveragesItem.spentCount
              : '0'
          }
          totalSteps={
            coveragesItem.limitAmt >= 0
              ? coveragesItem.limitAmt
              : coveragesItem.limitCount >= 0
              ? coveragesItem.limitCount
              : '0'
          }></CoveragesProgressBar>
      </Column>
      <Column className="coverages-list-column2">
        <div style={{marginBottom: '5px'}}>
          {coveragesItem.limitAmt >= 0 ? (
            coveragesItem.limitAmt === 999999999.99 ? (
              <strong style={coveragesListColumn2Styles}>
                {myCoverageStrings.unlimited}
              </strong>
            ) : (
              <strong style={coveragesListColumn2Styles}>
                {currencyFormat(coveragesItem.limitAmt)}
                {getCurrencyCode(coveragesItem.currency, 'myCoverages')}
              </strong>
            )
          ) : coveragesItem.limitCount >= 0 ? (
            <strong style={coveragesListColumn2Styles}>
              {coveragesItem.limitCount}
            </strong>
          ) : (
            <strong style={coveragesListColumn2Styles}>N/A</strong>
          )}
        </div>
        <div style={{marginBottom: '-1rem'}}>
          {coveragesItem.amtSpent >= 0 ? (
            <strong
              style={
                onWebMobile
                  ? {
                      ...fonts.S,
                      fontWeight: 'normal',
                    }
                  : {
                      ...fonts.M,
                      ...fonts.Bold,
                    }
              }>
              {currencyFormat(coveragesItem.amtSpent)}
              {getCurrencyCode(coveragesItem.currency, 'myCoverages')}
            </strong>
          ) : coveragesItem.limitCount >= 0 ? (
            <strong
              style={{
                ...fonts.M,
                ...fonts.Bold,
              }}>
              {coveragesItem.spentCount}
            </strong>
          ) : (
            <strong
              style={{
                ...fonts.M,
                ...fonts.Bold,
              }}>
              N/A
            </strong>
          )}
        </div>
      </Column>
    </Row>
  );
};

const mapStateToProps = ({globalStyles, language, user, strings}: any) => ({
  buStyles: globalStyles.value,
  language: language.value,
  userLanguage: user.value.language,
  myCoverageStrings: strings.value.pt.myCoverages,
});
export default compose(connect(mapStateToProps)(CoverageCard));
